import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#0b1e40] text-white pt-[60px] pb-7 px-[5%]">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            {/* Brand */}
            <div className="flex flex-col items-start">
              <a href="/">
                <img
                  src="assets/images/sugamya-finance-logo.png"
                  alt="Sugmya"
                  className="h-[60px] max-[375px]:h-[50px] block"
                />
              </a>
              <p className="text-white/50 text-sm leading-[1.75] mt-4 max-w-[280px]">
                We aim to reduce the "out-of-pocket" medical inflation that
                affects millions of families by providing a structured,
                subscription-based wellness ecosystem.
              </p>
            </div>

            {[
              // {
              //   title: "Quick Links",
              //   items: [
              //     { label: "Home", href: "#home" },
              //     { label: "Benefits", href: "#benefits" },
              //     { label: "Plans", href: "#plans" },
              //     { label: "Testimonials", href: "#testimonials" },
              //   ],
              // },
              // {
              //   title: "Policies",
              //   items: [
              //     { label: "Terms & Condition", href: "/term-of-use" },
              //     {
              //       label: "Shipping & Delivery",
              //       href: "/shipping-delivery-policy",
              //     },
              //     { label: "Privacy Policy", href: "/privacy-policy" },
              //     {
              //       label: "Cancellation Policy",
              //       href: "/cancellation-policy",
              //     },
              //   ],
              // },
              {
                title: "Reach Us",
                items: [
                  {
                    label:
                      "602, 6th Floor Plot No - 16, Rishabh Tower, Karkardooma, New Delhi, Delhi, 110092, India",
                    href: "#",
                  },
                  {
                    label: "dummy@sugamyafinance.com",
                    href: "mailto:dummy@sugamyafinance.com",
                  },
                  { label: "+91 1234567890", href: "tel:+911234567890" },
                ],
              },
            ].map((col) => (
              <div key={col.title}>
                <div className="font-[Sora,sans-serif] font-bold text-[15px] mb-[18px]">
                  {col.title}
                </div>
                {col.items.map((item, ii) => (
                  <a
                    key={ii}
                    href={item.href}
                    // onClick={(e) => {
                    //   if (item.href.startsWith("#")) {
                    //     e.preventDefault();
                    //     scrollTo(item.href.replace("#", ""));
                    //   }
                    // }}
                    target={
                      item.href.startsWith("http") ? "_blank" : "_self"
                    }
                    rel="noopener noreferrer"
                    className="block text-white/50 text-[13px] leading-[1.6] mb-2.5 no-underline transition-colors duration-200 cursor-pointer hover:text-[#9CCB3D]"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            ))}
          </div>

          {/* Bottom bar */}
          <div className="border-t border-white/10 pt-6 flex justify-between flex-wrap gap-3">
            <span className="text-white/35 text-[13px]">
              © 2026 Sugmya Finance. All Rights Reserved.
            </span>
            <span className="text-white/35 text-[13px]">
              Made with ❤️ for a healthier India
            </span>
          </div>
        </div>
      </footer>
  );
};

export default Footer;
